<template>
	<div class="service-all">
		<div v-if="showServiceList">
			<div class="service-operate-container module-item-style">
				<el-select v-model="serviceType" @change="filterData" placeholder="请选择">
					<el-option v-for="item in serviceTypeArr" :key="item.roleId" :label="item.roleName" :value="item.roleId">
					</el-option>
				</el-select>
				<el-input placeholder="请输入客服昵称/手机号/账号" v-model="name" class="service-search-input">
					<el-button slot="append" icon="el-icon-search" @click="filterData"></el-button>
				</el-input>
				<div class="wl-btn service-add-account" v-if="serviceRole == 0 || serviceRole == 1" @click="addChildAccount">
					添加子账号</div>
			</div>
			<div class="service-table-container">
				<div class="table-box">
					<el-table :data="tableData" stripe v-loading="isLoading" :header-cell-style="{ background: '#f2f2f2' }"
						style="border: 1px solid #ebeef5;">
						<el-table-column width="240px" prop="csName" label="客服名称">
							<template slot-scope="scope">
								<div style="display: flex;">
									<img class="table-image table-image-avatar " :src="avatarX(scope.row.csHeadimg)" alt="客服头像">
									<span style="flex: 1;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;" class="name">{{
										scope.row.csName }}</span>
								</div>
							</template>
						</el-table-column>

						<el-table-column v-if="!showPannel" prop="csMobile" label="账号(手机号)">
						</el-table-column>
						<el-table-column v-if="!showPannel" label="服务上限">
							<template slot-scope="scope">
								<div class="server-text" v-if="!scope.row.active">
									<div v-if="scope.row.csType != 0">
										<el-button type="text" @click="handleClickOpenInput(scope.$index)" size="mini"><i
												class="el-icon-edit"></i></el-button>
										<span class="text"> {{ scope.row.maxServiceNum }}</span>
									</div>
									<div v-else>
										<el-button v-if="serviceRole == 0" type="text" @click="handleClickOpenInput(scope.$index)"
											size="mini"><i class="el-icon-edit"></i></el-button>
										<span class="text"> {{ scope.row.maxServiceNum }}</span>
									</div>
								</div>
								<div class="server-input" v-else>
									<el-input @blur="handleChangeEvent(scope.$index, scope.row)"
										@change="handleChangeEvent(scope.$index, scope.row, 'change')" size="small"
										v-model="scope.row.maxServiceNum"></el-input>
								</div>
							</template>
						</el-table-column>
						<el-table-column v-if="!showPannel" label="在线状态">
							<template slot-scope="scope">
								<div class="onlineSta" v-if="scope.row.isOnline == 0">
									<img :src="imgOffline" v-if="scope.row.isOnline == 0" alt="">
									<span class="onlineStatus offline">{{ scope.row.isOnlineStr }}</span>
								</div>
								<div class="onlineSta" v-if="scope.row.isOnline == 1">
									<img :src="pcOnImg" v-if="scope.row.showPcIcon == 1" class="mgt5" alt="">
									<img :src="clientOnImg" v-if="scope.row.showClientIcon == 1" class="mgt5" alt="">
									<img :src="mobileOnImg" v-if="scope.row.showAppIcon == 1" alt="">
									<span class="onlineStatus online">{{ scope.row.isOnlineStr }}</span>
								</div>
								<div class="onlineSta" v-if="scope.row.isOnline == 2">
									<img :src="pcOffImg" v-if="scope.row.showPcIcon == 1" class="mgt5" alt="">
									<img :src="clientOffImg" v-if="scope.row.showClientIcon == 1" class="mgt5" alt="">
									<img :src="mobileOffImg" v-if="scope.row.showAppIcon == 1" alt="">
									<!--<img :src="imgHold" alt=""> -->
									<span class="onlineStatus rest">{{ scope.row.isOnlineStr }}</span>
								</div>
							</template>
						</el-table-column>
						<el-table-column v-if="!showPannel" prop="roleName" label="角色">
						</el-table-column>
						<el-table-column label="操作" width="180">
							<template slot-scope="scope">
								<div v-if="serviceRole == 0 || serviceRole == 1" class="btnWrap">
									<button class="tb-btn tb-btn-edit" @click="handleClickChangePwd(scope.row)"
										style="margin:0 10px 10px 0;">
										修改密码
									</button>
									<button class="tb-btn tb-btn-edit" style="margin:0 10px 10px 0;" @click="handleButton('editMethods',
										scope.row)">编辑
									</button>
									<button class="tb-btn tb-btn-edit" style="margin:0 10px 10px 0;"
										@click="handleButton('viewEvaluation', scope.row)">评价详情
									</button>

									<button v-if="aiRobotSwitch" class="tb-btn tb-btn-edit" style="margin:0 10px 10px 0;"
										@click="handleButton('aiHostingSetting', scope.row)"
									>AI托管设置
									</button>

									<button class="tb-btn tb-btn-del" style="margin:0 10px 10px 0;"
										@click="handleButton('delMethods', scope.row)" v-if="scope.row.csType != 0">删除
									</button>
									<div style="margin:0 0 10px 0;" v-if="(scope.row.isOnline == 1 || scope.row.isOnline == 2
									) && scope.row.showButtonAuth == 1">
										<button class="tb-btn tb-btn-del" style="margin:0 10px 10px 0;"
											@click="handleButton('offline', scope.row)">
											下线
										</button>
										<button class="tb-btn tb-btn-del" style="margin:0 10px 10px 0;"
											@click="handleButton('online', scope.row)" v-if="scope.row.invisibleStatusButton == 0">在线
										</button>
										<button class="tb-btn tb-btn-del" style="margin:0 10px 10px 0;"
											@click="handleButton('rest', scope.row)" v-if="scope.row.invisibleStatusButton == 1">休息
										</button>
									</div>
								</div>
								<div v-else>
									无操作权限
								</div>
							</template>
						</el-table-column>
					</el-table>

					<!--    分页-->

					<pagenations :total="total" :size="pageSize" @pageHandler="pageOperate">
					</pagenations>
				</div>
			</div>
		</div>

		<el-dialog title="修改密码" :visible.sync="dialogVisible" width="30%">
			<el-form :model="accountForm" :rules="accountFormRules" ref="accountForm" label-width="100px"
				class="setting-change-pwd-form">
				<el-form-item label="原密码" prop="oldPwd" v-if="!showOldPwd">
					<el-input type="password" v-model="accountForm.oldPassword" autocomplete="off"
						placeholder="请输入原密码"></el-input>
				</el-form-item>
				<el-form-item label="新密码" prop="newPwd">
					<el-input type="password" v-model="accountForm.newPassword" minlength="6" maxlength="32" autocomplete="off"
						placeholder="请输入6～32位字母或数字"></el-input>
				</el-form-item>
				<el-form-item label="确认新密码" prop="checkPwd">
					<el-input type="password" v-model="accountForm.confirmPass" minlength="6" maxlength="32" autocomplete="off"
						placeholder="请确认新密码"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="changePwdConfirm('accountForm')">确 定</el-button>
			</span>
		</el-dialog>

		<ai-hosting-setting
			v-model="aiHostingVisible"
			:service-data="aiHostingServiceData"
			@confirm="handleAiHostingConfirm">
		</ai-hosting-setting>

		<transition name="fade-transform" mode="out-in">
			<router-view v-if="!showServiceList" />
		</transition>

		<div class="pannelBox" v-if="showPannel">
			<serviceEvaluationDetail :evaluateData="evaluateData" @serviceEvaluateHandler="serviceEvaluateHandler" />
		</div>
	</div>
</template>

<script>
import pagenations from '@/components/pagenations/pagenations'
import serviceEvaluationDetail from './components/service-evaluation-detail'
import aiHostingSetting from './components/ai-hosting-setting'

import avatar0 from '@/assets/images/client_avatar_empty.png'
import avatar1 from '@/assets/images/client_avatar1.png'
import avatar2 from '@/assets/images/client_avatar2.png'
import avatar3 from '@/assets/images/client_avatar3.png'
import avatar4 from '@/assets/images/client_avatar4.png'
import avatar5 from '@/assets/images/client_avatar5.png'
import avatar6 from '@/assets/images/client_avatar6.png'
import avatar7 from '@/assets/images/client_avatar7.png'
import imgHold from '@/assets/images/icon_server_holdon.png'
import imgOffline from '@/assets/images/icon_server_offline.png'
import imgOnline from '@/assets/images/icon_server_online.png'
import pcOnImg from '@/assets/images/icon_pc_on.png'
import pcOffImg from '@/assets/images/icon_pc_off.png'
import clientOnImg from '@/assets/images/icon_client_on.png'
import clientOffImg from '@/assets/images/icon_client_off.png'
import mobileOnImg from '@/assets/images/icon_mobile_on.png'
import mobileOffImg from '@/assets/images/icon_mobile_off.png'


export default {
	name: 'service-all',
	components: {
		pagenations,
		serviceEvaluationDetail,
		aiHostingSetting
	},
	data() {
		let validatePass = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请输入新密码'));
			} else if (value.trim().length < 6) {
				callback(new Error('请输入至少6位新密码'));
			} else if (value.trim().length > 32) {
				callback(new Error('最多输入32位新密码'));
			} else {
				callback();
			}
		};
		let validateCheckPass = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请再次输入密码'));
			} else if (value !== this.roleForm.csPwd) {
				callback(new Error('两次输入密码不一致!'));
			} else {
				callback();
			}
		};
		return {
			evaluateData: '',
			showPannel: false,
			imgHold: imgHold,
			imgOffline: imgOffline,
			imgOnline: imgOnline,
			pcOnImg: pcOnImg,
			pcOffImg: pcOffImg,
			clientOnImg: clientOnImg,
			clientOffImg: clientOffImg,
			mobileOnImg: mobileOnImg,
			mobileOffImg: mobileOffImg,
			dialogVisible: false,
			aiHostingVisible: false,
			aiHostingServiceData: {},
			showServiceList: true,
			name: '',
			isLoading: false,
			tableHandler: [
				{ label: "编辑", type: 'edit', methods: 'editMethods' },
				{ label: "删除", type: 'del', methods: 'delMethods', },
			],
			serviceType: '',
			serviceTypeArr: [
				{ roleName: '全部', roleId: '' }
			],
			tableData: [],
			tableHead: [
				{
					label: '头像',
					value: 'csHeadimg',
					type: 'image',
					width: '60',
					operate: false
				}, {
					label: '昵称',
					value: 'csName',
					operate: false,
				}, {
					label: '账号',
					value: 'csMobile',
					operate: false
				}, {
					label: '手机号',
					value: 'csMobile',
					operate: false,
				}, {
					label: '在线状态',
					value: 'isOnlineStr',
					operate: false,
				}, {
					label: '角色',
					value: 'roleName',
					operate: false,
				}, {
					label: '操作',
					value: '',
					width: '150',
					operate: true,
				}
			],
			total: 0,
			currentPage: 1,
			pageSize: 10,
			accountForm: {
				csMobile: '',
				oldPassword: '',
				newPassword: '',
				confirmPass: ''
			},
			showOldPwd: 1, // 1代表下级 0不是下级 修改下级密码时不需要原密码
			accountFormRules: {
				oldPassword: [
					{ required: true, message: '请输入原密码', trigger: 'blur' }
				],
				newPassword: [
					{ required: true, validator: validatePass, trigger: 'blur' }
				],
				confirmPass: [
					{ required: true, validator: validateCheckPass, trigger: 'blur' }
				],
			},
			aiRobotSwitch: false,
		}
	},
	computed: {
		serviceRole() {
			return this.$store.state.user.roles
		}
	},
	watch: {
		$route: {
			handler: function (val, oldVal) {

				if (val.name == "serviceAdd" || val.name == "serviceEdit") {
					this.showServiceList = false
				} else {
					this.getAllRole()
					this.showServiceList = true
				}
			},
			// 深度观察监听
			deep: true
		}
	},
	created() {
		this.getAllRole()
		this.getRoleType()
		this.getRobotConfig()
	},
	mounted() {
		let val = this.$route
		if (val.name == "serviceAdd" || val.name == "serviceEdit") {
			this.showServiceList = false
		} else {
			this.showServiceList = true
		}
		//
	},
	methods: {
		 getRobotConfig() {
      this.$http.getRobotConfigAPI().then(res => {
        if (res.status == 1) {
					this.aiRobotSwitch = res.data.is_open_ai_robot == 1 ? true : false
        }
      })
    },
		serviceEvaluateHandler(msg) {
			this.showPannel = false
		},
		// 点击服务上限修改按钮
		handleClickOpenInput(index) {
			const tableData = this.tableData
			tableData.forEach((item, num) => {
				this.$set(this.tableData[num], 'active', false)
			})
			this.$set(this.tableData[index], 'active', true)
		},
		handleChangeEvent(index, row, str) {
			this.$set(this.tableData[index], 'active', false)
			let postEditData = {
				id: row.csId,
				csName: row.csName,
				csRealname: row.csRealname,
				csNo: row.csNo,
				maxServiceNum: row.maxServiceNum,
				csType: row.csType,
			}
			this.$http.editChildServiceAPI(postEditData).then(res => {
				if (res.status == 1) {
					this.$message({
						message: res.msg,
						type: 'success',
					})
					this.getAllRole()
				} else {
					this.$message({
						message: res.msg,
						type: 'error',
					})

				}
			})
		},
		// 修改密码
		handleClickChangePwd(row) {
			this.dialogVisible = true
			this.showOldPwd = row.isSubordinate
			this.accountForm = {
				csMobile: row.csMobile,
				oldPassword: '',
				newPassword: '',
				confirmPass: ''
			}
		},
		changePwdConfirm(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					let postData = this.accountForm
					this.$http.changePasswordAPI(postData).then(res => {
						if (res.status == 1) {
							this.$message({
								message: res.msg,
								type: 'success',
							})
							this.dialogVisible = false
						} else {
							this.$message({
								message: res.msg,
								type: 'error',
							})
						}
					})
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		/**
		 * 显示访客头像
		 * 截取头像名称中的数字
		 */
		avatarX(avatar) {
			const img = avatar.substring(avatar.length - 5, avatar.length - 4)
			switch (img) {
				case 'y':
					return avatar0
					break
				case '1':
					return avatar1
					break
				case '2':
					return avatar2
					break
				case '3':
					return avatar3
					break
				case '4':
					return avatar4
					break
				case '5':
					return avatar5
					break
				case '6':
					return avatar6
					break
				case '7':
					return avatar7
					break
				default:
					return avatar
					break
			}
		},
		/**
		 * 表单操作
		 * @param val
		 */
		handleButton(val, row) {
			if (val == 'viewEvaluation') {
				this.showPannel = true
				this.evaluateData = row.csId
			}
			if (val == 'aiHostingSetting') {
				this.aiHostingVisible = true
				this.$http.getAiCsTrusteeship({
					csId: row.csId
				}).then(res => {
					if (res.status == 1) {
						this.aiHostingServiceData = {
							csId: row.csId,
							enabled: res.data.aiTrusteeshipEnabled == 1,
						}
					} else {
						this.$message({
							message: res.msg,
							type: 'error',
						})
					}
				})
			}
			if (val == "delMethods") {

				if (row.csType == 0) {
					this.$message({
						message: '超级管理员账号无法删除！',
						type: 'error',
					})
					return false
				} else {
					this.$confirm('将要进行删除操作, 是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.delChildAccount(row.csId)
					}).catch(() => {

					});

				}
			} else if (val == 'editMethods') {
				if (row.csType == 0 && this.serviceRole != 0) {
					this.$message({
						message: '无操作权限！',
						type: 'error',
					})
					return false
				} else {
					this.$router.push({
						name: 'serviceEdit',
						query: {
							id: row.csId
						}
					})
				}

			}
			if (val == 'offline') {
				this.$http.offlineChildServiceAPI({
					csId: row.csId
				}).then(res => {
					if (res.status == 1) {
						this.getAllRole()
						this.$message({
							message: res.msg,
							type: 'success',
						})
					} else {
						this.$message({
							message: res.msg,
							type: 'error',
						})
					}
				})
			}
			if (val == 'online') {
				this.$http.changeChildServiceStatusAPI({
					csId: row.csId,
					status: 'online'
				}).then(res => {
					if (res.status == 1) {
						this.getAllRole()
						this.$message({
							message: res.msg,
							type: 'success',
						})
					} else {
						this.$message({
							message: res.msg,
							type: 'error',
						})
					}
				})
			}
			if (val == 'rest') {
				this.$http.changeChildServiceStatusAPI({
					csId: row.csId,
					status: 'offline'
				}).then(res => {
					if (res.status == 1) {
						this.getAllRole()
						this.$message({
							message: res.msg,
							type: 'success',
						})
					} else {
						this.$message({
							message: res.msg,
							type: 'error',
						})
					}
				})
			}

		},
		/**
		 * AI托管设置确认
		 */
		handleAiHostingConfirm(postData) {
			this.$http.toggleAiCsTrusteeship(postData).then(res => {
				if (res.status == 1) {
					this.$message({
						message: '保存成功',
						type: 'success',
					})
					this.aiHostingVisible = false
					this.getAllRole()
				} else {
					this.$message({
						message: res.msg || '保存失败',
						type: 'error',
					})
				}
			})
		},
		/**
		 *  分页操作
		 * @param val
		 */
		pageOperate(val) {
			if (val.type == 'currentChange') {
				this.currentPage = val.val
			} else if (val.type == "sizeChange") {
				this.pageSize = val.val
			}
			this.getAllRole()
		},
		/**
		 *
		 * 添加子账号
		 */
		addChildAccount() {

			this.$router.push({
				name: 'serviceAdd'
			})
		},
		delChildAccount(id) {
			this.$http.delChildServiceAPI({
				id
			}).then(res => {
				if (res.status == 1) {
					this.getAllRole()
					this.$message({
						message: res.msg,
						type: 'success',
					})
				} else {
					this.$message({
						message: res.msg,
						type: 'error',
					})
				}
			})
		},
		/**
		 * 获取角色列表
		 */
		getAllRole() {
			let postParams = {
				pageNum: this.currentPage,
				pageSize: this.pageSize,
				name: this.name,
				type: this.serviceType
			}
			this.isLoading = true
			this.$http.getServiceListAPI(postParams).then(res => {
				if (res.status == 1) {
					this.tableData = res.data.csList// res.data
					this.total = res.data.total
				}
				this.isLoading = false
			}).catch(err => {
				this.isLoading = false
			})
		},
		/**
		 * 筛选
		 */
		filterData() {
			let postParams = {
				pageNum: 1,
				pageSize: this.pageSize,
				name: this.name,
				type: this.serviceType
			}
			this.$http.getServiceListAPI(postParams).then(res => {
				if (res.status == 1) {
					this.tableData = res.data.csList// res.data
					this.total = res.data.total
				}
			}).catch(err => {

			})
		},
		/**
		 * 获取角色类型
		 */
		getRoleType() {
			this.$http.getServiceTypeListAPI().then(res => {
				if (res.status == 1) {
					this.serviceTypeArr = this.serviceTypeArr.concat(res.data.cstypeList)
				}
			}).catch(err => {

			})
		}
	}
}
</script>

<style lang="scss">
.service-all {
	.pannelBox {
		position: absolute;
		top: 0;
		right: 1px;
		bottom: 1px;
		width: 68%;
		z-index: 10;
		border-top: 1px solid #E5E5E5;
		border-left: 1px solid #E5E5E5;
		box-shadow: 1px 10px 10px rgba(0, 0, 0, 0.3);
		transition: width .3s linear;
		background: #fff;
	}

	.onlineSta {
		img {
			width: 14px;
			display: inline-block;
			vertical-align: top;
			margin: 0 2px;

			&.mgt5 {
				margin-top: 2px;
				width: 18px;
			}
		}
	}

	.table-box .table-image-avatar {
		display: inline-block;
	}

	.table-box {
		.btnWrap {}
	}

	.name {
		line-height: 40px;
		display: inline-block;
		vertical-align: top;
		margin-left: 5px;
	}

	.server-input {
		width: 100px;
	}

	.service-operate-container {
		display: flex;

		.service-search-input {
			width: 300px;
			margin-left: 20px;
		}

		.service-add-account {
			margin-left: auto;
		}
	}

	.service-table-container {
		margin-top: 15px;
		padding: $mainContentPadding;
		background-color: #fff;
		border-radius: $mainBorderRadius;

		.onlineStatus {
			display: inline-block;
			vertical-align: top;
			margin-left: 5px;

			&.online {
				color: #09BB07;
			}

			&.offline {
				line-height: 12px;
			}

			&.rest {
				color: #D2A300;
			}
		}
	}
}
</style>
